import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import temporaryAuthTokensResource from 'src/actions/temporaryAuthTokens/temporaryAuthTokensResource';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(temporaryAuthTokensResource.effects.facebookLoginTemporaryToken());
  }, [dispatch]);

  return useSelector(state => {
    return state['temporaryAuthTokens'];
  });
}
